module.exports = __webpack_public_path__ + "img/development_bg.5bc90577.png";